var React = require('react');

function Poi (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0022 29L18.6501 14.5C22.4927 8.05427 17.6875 0 10.0022 0C2.31298 0 -2.49229 8.05427 1.35432 14.5L10.0022 29Z","fill":"#F18841"}));
}

Poi.defaultProps = {"width":"20","height":"29","viewBox":"0 0 20 29","fill":"none"};

module.exports = Poi;

Poi.default = Poi;
